import { css as _css } from "@emotion/core";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Chart, registerables } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import { isClientSide } from '../client-side';
import * as styles from './doughnut-graph.style';

// Required by ChartJS to avoid crashing
import { jsx as ___EmotionJSX } from "@emotion/core";
if (isClientSide && registerables) {
  Chart.register(...registerables);
}
var DoughnutGraph = _ref => {
  var title = _ref.title,
    data = _ref.data,
    colours = _ref.colours,
    options = _ref.options,
    className = _ref.className;
  var _useState = useState({
      show: false
    }),
    _useState2 = _slicedToArray(_useState, 2),
    tooltip = _useState2[0],
    setTooltip = _useState2[1];
  var formatDoughnutGraphData = () => ({
    labels: data.map(datum => datum.label),
    datasets: [{
      label: title,
      data: data.map(datum => datum.value),
      backgroundColor: colours
    }]
  });
  var tooltipHandler = ctx => {
    var _ctx$tooltip;
    var show = (ctx === null || ctx === void 0 ? void 0 : (_ctx$tooltip = ctx.tooltip) === null || _ctx$tooltip === void 0 ? void 0 : _ctx$tooltip.opacity) !== 0;
    var dataPoints = ctx.tooltip.dataPoints;
    var label = dataPoints[0].label;
    if (tooltip.show && !show) {
      setTooltip({
        show: false
      });
    } else if (
    // showing a hidden tooltip
    !tooltip.show && show ||
    // moving to a new data point
    tooltip.show && show && label !== tooltip.label) {
      // Work out the centerpoint of the arc being hovered over
      var _dataPoints$0$element = dataPoints[0].element,
        elementX = _dataPoints$0$element.x,
        elementY = _dataPoints$0$element.y,
        innerRadius = _dataPoints$0$element.innerRadius,
        outerRadius = _dataPoints$0$element.outerRadius,
        startAngle = _dataPoints$0$element.startAngle,
        endAngle = _dataPoints$0$element.endAngle;
      var radius = (innerRadius + outerRadius) / 2;
      var angle = (startAngle + endAngle) / 2;
      var xCoord = elementX + Math.cos(angle) * radius;
      var yCoord = elementY + Math.sin(angle) * radius;
      setTooltip({
        show: true,
        label,
        ctx,
        pos: {
          x: xCoord,
          y: yCoord
        }
      });
    }
  };
  var doughnutOptions = _ref2 => {
    var disableAnimation = _ref2.disableAnimation;
    return {
      plugins: {
        legend: {
          display: false
        },
        tooltip: {
          enabled: false,
          external: tooltipHandler
        }
      },
      animation: {
        duration: disableAnimation ? 0 : undefined
      },
      datasets: {
        doughnut: {
          hoverBorderWidth: 2,
          hoverBorderColor: 'rgba(0, 0, 0, 0.2)',
          borderRadius: 3,
          cutout: '60%'
        }
      }
    };
  };
  var renderTooltip = _ref3 => {
    var dataPoints = _ref3.tooltip.dataPoints;
    var _dataPoints$ = dataPoints[0],
      label = _dataPoints$.label,
      formattedValue = _dataPoints$.formattedValue,
      dataIndex = _dataPoints$.dataIndex,
      dataset = _dataPoints$.dataset;
    return ___EmotionJSX("div", {
      css: styles.tooltip({
        top: tooltip.pos.y,
        left: tooltip.pos.x
      })
    }, ___EmotionJSX("div", {
      css: styles.dataItem
    }, ___EmotionJSX("div", {
      css: styles.roundel({
        colour: dataset.backgroundColor[dataIndex]
      })
    }), ___EmotionJSX("div", null, label), ___EmotionJSX("div", {
      css: styles.tooltipValue
    }, formattedValue, "%")));
  };
  return ___EmotionJSX("div", {
    css: styles.doughnutGraph,
    className: className
  }, ___EmotionJSX("div", {
    css: styles.title
  }, title), ___EmotionJSX("div", {
    css: styles.graph
  }, isClientSide && ___EmotionJSX(Doughnut, {
    data: formatDoughnutGraphData(),
    options: doughnutOptions(options)
  }), tooltip.show && renderTooltip(tooltip.ctx)), ___EmotionJSX("div", {
    css: styles.spacer
  }), ___EmotionJSX("ul", {
    css: styles.legend
  }, data.map((datum, index) => ___EmotionJSX("li", {
    css: styles.legendItem
  }, ___EmotionJSX("div", {
    css: styles.legendLabel
  }, ___EmotionJSX("div", {
    css: /*#__PURE__*/_css([styles.roundel({
      colour: colours[index]
    }), styles.legendRoundelSpacer])
  }), ___EmotionJSX("div", null, datum.label)), ___EmotionJSX("div", {
    css: styles.line
  }), ___EmotionJSX("div", {
    css: styles.legendValue
  }, datum.value, "%")))));
};
DoughnutGraph.propTypes = {
  title: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.shape()),
  colours: PropTypes.arrayOf(PropTypes.string),
  options: PropTypes.shape({
    disableAnimation: PropTypes.bool
  }),
  className: PropTypes.string
};
DoughnutGraph.defaultProps = {
  title: '',
  options: {},
  data: [],
  colours: [],
  className: ''
};
export default DoughnutGraph;